<template>
  <div class="vx-row mb-2">
    <div class="vx-col w-full">
      <!-- <vs-divider>{{structure.label}}</vs-divider>
      <v-select 
        class="w-full"
        name="field"
        v-validate="structure.validation"
        v-model="selected"
        :options="structure.data"
        :dir="$vs.rtl ? 'rtl' : 'ltr'"
      /> 
      <span class="text-danger text-sm" v-show="errors.has('field')">{{ errors.first('field') }}</span>

      -->

      <span class="text-xs">{{fieldLabel}}</span>

      <vs-row class="p-2">
        <vs-col
          class="font-semibold p-2"
          vs-type="flex"
          :vs-w="structure.width"
          v-for="(val,id) in structure.data"
          :key="id"
        >
          <vs-radio v-model="selected" :vs-value="val.id+index">{{val.label}}</vs-radio>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template> 
<script>
import vSelect from "vue-select";
import { sidebarMixin } from "../sidebarMixin";
export default {
    mixins: [sidebarMixin],
  components: {
    vSelect,
  },
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: "",
    validation: "",
  },
  data() {
    return {
      selected: this.value,
    };
  },
 
  created() {
    //we emit the default value because if user does not touch it won't be captured in the array
    this.$emit("input", { index: this.index, value: this.value });

    this.selected = this.selected + this.index;

    this.$watch("selected", (value) => {
      var errorVal = false;
      if (value != null) {
        errorVal = true;
      }

      this.$emit("error", { index: this.index, value: errorVal });
      this.$emit("input", {
        index: this.index,
        value: value.replace(this.index, ""),
      });
    });
  },
};
</script>